import './CasDataGridPro.scss';

import { useState } from 'react';
import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro';

import CasIconButton from '../CasButton/CasIconButton';
import { CasStackRow } from '../CasStack/CasStackRow';

export default function CasDataGridPro(props: DataGridProProps) {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleTableFullScreen = () => {
    setIsFullScreen((prev) => !prev);
  };

  return (
    <div className={isFullScreen ? 'table-fullscreen' : ''}>
      <CasStackRow alignItems="center" justifyContent="flex-end">
        <CasIconButton
          icon={isFullScreen ? 'mdi:fullscreen-exit' : 'mdi:fullscreen'}
          onClick={handleTableFullScreen}
          tooltip="Toggle full screen"
        />
      </CasStackRow>

      <DataGridPro {...props} className="CasDataGridPro" />
    </div>
  );
}
